import React, { useState } from 'react'
import { FilterInput } from '@nyos/shared'

interface TurninsDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const TurninsDrawer: React.FC<TurninsDrawerProps> = ({ isOpen, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('')

  const mockTurnins = [
    { id: 'CR-001', type: 'Crew Report', description: 'Switch malfunction on SW-03', status: 'Pending', timestamp: '2026-05-11 10:30' },
    { id: 'CR-002', type: 'Crew Report', description: 'Rail car stuck on Track 2', status: 'Pending', timestamp: '2026-05-11 09:15' },
    { id: 'ME-001', type: 'Movement Event', description: 'Unexpected movement detected', status: 'Resolved', timestamp: '2026-05-11 08:45' },
    { id: 'CR-003', type: 'Crew Report', description: 'Track alignment issue', status: 'Pending', timestamp: '2026-05-11 07:30' },
    { id: 'ME-002', type: 'Movement Event', description: 'Rail car A completed movement', status: 'Resolved', timestamp: '2026-05-11 06:15' },
  ]

  const filteredTurnins = mockTurnins.filter(
    t => 
      t.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.type.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Resolved':
        return 'var(--switch-normal)'
      case 'Pending':
        return 'var(--status-red)'
      default:
        return 'var(--text-muted)'
    }
  }

  const handleResolve = (id: string) => {
    // TODO: Implement resolve logic
    console.log('Resolving:', id)
  }

  if (!isOpen) return null

  return (
    <div data-drawer="turnins" className="drawer-container open">
      <div className="drawer-overlay" onClick={onClose}></div>
      <div className="drawer">
        <button className="drawer-close" onClick={onClose}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className="inspector-drawer">
          <h2>Turn-ins & Resolution</h2>
          <div style={{ marginBottom: '16px' }}>
            <FilterInput
              aria-label="Filter turn-ins"
              placeholder="Search crew reports, movement events..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <button
              style={{
                flex: 1,
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid var(--accent-blue)',
                background: 'var(--accent-blue)',
                color: '#fff',
                fontSize: '12px',
                cursor: 'pointer',
              }}
            >
              All
            </button>
            <button
              style={{
                flex: 1,
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid var(--border-color)',
                background: 'transparent',
                color: 'var(--text-primary)',
                fontSize: '12px',
                cursor: 'pointer',
              }}
            >
              Pending
            </button>
            <button
              style={{
                flex: 1,
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid var(--border-color)',
                background: 'transparent',
                color: 'var(--text-primary)',
                fontSize: '12px',
                cursor: 'pointer',
              }}
            >
              Resolved
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {filteredTurnins.length === 0 ? (
              <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '32px' }}>
                No turn-ins found matching "{searchQuery}"
              </div>
            ) : (
              filteredTurnins.map(turnin => (
                <div
                  key={turnin.id}
                  style={{
                    padding: '12px',
                    borderRadius: '4px',
                    background: 'var(--hover-bg)',
                    border: '1px solid var(--border-color)',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <span style={{ fontWeight: 600, fontSize: '14px', color: 'var(--text-primary)' }}>
                      {turnin.id}
                    </span>
                    <span style={{ fontSize: '12px', color: getStatusColor(turnin.status), fontWeight: 500 }}>
                      {turnin.status}
                    </span>
                  </div>
                  <div style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '8px' }}>
                    {turnin.description}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                      {turnin.type} • {turnin.timestamp}
                    </span>
                    {turnin.status === 'Pending' && (
                      <button
                        onClick={() => handleResolve(turnin.id)}
                        style={{
                          padding: '6px 12px',
                          borderRadius: '4px',
                          border: 'none',
                          background: 'var(--switch-normal)',
                          color: '#fff',
                          fontSize: '12px',
                          cursor: 'pointer',
                          fontWeight: 500,
                        }}
                      >
                        Resolve
                      </button>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(TurninsDrawer)
